import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const AlertsContext = createContext();

export const AlertsContextProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);

    const getAlerts = (token) => {
        axios.get('https://firewatch-api.space-eyes.com/user/notifications', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => {
            setAlerts(response.data.alerts)
        }).catch((error) => {
            console.log('error calling alerts API: ', error);
        }) 
    }

    const value = {
        alerts,
        setAlerts,
        getAlerts
    };
  
    return (
        <AlertsContext.Provider 
            value={value}
        >
        {children}
        </AlertsContext.Provider>
    );
};

export const useAlertsContext = () => useContext(AlertsContext);
